/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tempDir: NonNullable<unknown> }} Video_Export_Retry_WarningInputs */

const en_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error exporting your video to the selected target folder. Target folder has been updated to temp directory: ${i?.tempDir}`)
};

const fr_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite lors de l'exportation de votre video vers le dossier cible selectionne. Le dossier cible a ete remplace par le dossier temporaire : ${i?.tempDir}`)
};

const de_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beim Exportieren Ihres Videos in den ausgewählten Zielordner ist ein Fehler aufgetreten. Der Zielordner wurde in das temporäre Verzeichnis ${i?.tempDir} geändert.`)
};

const it_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante l'esportazione del video nella cartella di destinazione selezionata. La cartella di destinazione è stata aggiornata nella directory temporanea: ${i?.tempDir}`)
};

const ru_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Произошла ошибка при экспорте вашего видео в выбранную целевую папку. Целевая папка обновлена до временного каталога: ${i?.tempDir}`)
};

const es_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se produjo un error al exportar el video a la carpeta de destino seleccionada. La carpeta de destino se actualizó al directorio temporal: ${i?.tempDir}`)
};

const zh_cn2_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出视频到选定目标文件夹时出错。目标文件夹已更新为临时目录：${i?.tempDir}`)
};

const ja_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`選択したターゲットフォルダへのビデオのエクスポート中にエラーが発生しました。ターゲットフォルダは一時ディレクトリに更新されました: ${i?.tempDir}`)
};

const hi_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपके वीडियो को चयनित लक्ष्य फ़ोल्डर में निर्यात करने में त्रुटि हुई। लक्ष्य फ़ोल्डर को अस्थायी निर्देशिका: ${i?.tempDir} में अपडेट कर दिया गया है।`)
};

const pt_pt2_video_export_retry_warning = /** @type {(inputs: Video_Export_Retry_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro ao exportar seu vídeo para a pasta de destino selecionada. A pasta de destino foi atualizada para o diretório temporário: ${i?.tempDir}`)
};

/**
* | output |
* | --- |
* | "There was an error exporting your video to the selected target folder. Target folder has been updated to temp directory: {tempDir}" |
*
* @param {Video_Export_Retry_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_retry_warning = /** @type {((inputs: Video_Export_Retry_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Retry_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_retry_warning(inputs)
	if (locale === "de") return de_video_export_retry_warning(inputs)
	if (locale === "it") return it_video_export_retry_warning(inputs)
	if (locale === "ru") return ru_video_export_retry_warning(inputs)
	if (locale === "es") return es_video_export_retry_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_retry_warning(inputs)
	if (locale === "ja") return ja_video_export_retry_warning(inputs)
	if (locale === "hi") return hi_video_export_retry_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_retry_warning(inputs)
	return en_video_export_retry_warning(inputs)
});